const actions = {
    PURCHASE_INVOICE_DETAILS_START: 'PURCHASE_INVOICE_DETAILS_START',
    PURCHASE_INVOICE_DETAILS_SUCCESS: 'PURCHASE_INVOICE_DETAILS_SUCCESS',
    SALES_INVOICE_DETAILS_FAILURE: 'PURCHASE_INVOICE_DETAILS_FAILURE',

    PURCHASE_TRANSACTION_DETAILS_START: 'PURCHASE_TRANSACTION_DETAILS_START',
    PURCHASE_TRANSACTION_DETAILS_SUCCESS: 'PURCHASE_TRANSACTION_DETAILS_SUCCESS',
    PURCHASE_TRANSACTION_DETAILS_FAILURE: 'PURCHASE_TRANSACTION_DETAILS_FAILURE',

    CLEAR_PURCHASE_TRANSACTION_DETAILS_START: 'CLEAR_PURCHASE_TRANSACTION_DETAILS_START',
    CLEAR_PURCHASE_TRANSACTION_DETAILS_SUCCESS: 'CLEAR_PURCHASE_TRANSACTION_DETAILS_SUCCESS'
};

export default actions;